import React from 'react';
import { Container, Row, Col, CardBody, Card } from 'reactstrap';
import PasswordInput from '../../common/PasswordInput';

const PasswordComponent = () => {
    return (
        <div className='page-content components'>
            <Container>
                <Card>
                    <CardBody>
                        <h2 className="mb-4">Password Input Showcase</h2>

                        {/* First Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <PasswordInput
                                    name="primaryPassword"
                                    id="primaryPasswordInput"
                                    required={true}
                                    layout="below"
                                    placeholder="Enter your password"
                                    showHelp={true}
                                    helpText="Please enter a strong password."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<PasswordInput
    name="primaryPassword"
    id="primaryPasswordInput"
    required={true}
    layout="below"
    placeholder="Enter your password"
    showHelp={true}
    helpText="Please enter a strong password."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Second Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <PasswordInput
                                    name="businessPassword"
                                    id="businessPasswordInput"
                                    required={true}
                                    layout="below"
                                    placeholder="Enter your business password"
                                    showHelp={true}
                                    helpText="This password is required for business."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<PasswordInput
    name="businessPassword"
    id="businessPasswordInput"
    required={true}
    layout="below"
    placeholder="Enter your business password"
    showHelp={true}
    helpText="This password is required for business."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Third Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <PasswordInput
                                    name="optionalPassword"
                                    id="optionalPasswordInput"
                                    required={false}
                                    layout="below"
                                    placeholder="Enter optional password"
                                    showHelp={true}
                                    helpText="This password is optional."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<PasswordInput
    name="optionalPassword"
    id="optionalPasswordInput"
    required={false}
    layout="below"
    placeholder="Enter optional password"
    showHelp={true}
    helpText="This password is optional."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Fourth Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <PasswordInput
                                    name="secondaryPassword"
                                    id="secondaryPasswordInput"
                                    required={true}
                                    layout="below"
                                    placeholder="Enter your secondary password"
                                    showHelp={true}
                                    helpText="This password is required for secondary access."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<PasswordInput
    name="secondaryPassword"
    id="secondaryPasswordInput"
    required={true}
    layout="below"
    placeholder="Enter your secondary password"
    showHelp={true}
    helpText="This password is required for secondary access."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};

export default PasswordComponent;
